module.exports = __webpack_public_path__ + "img/photo-moh2.f6cab4c6.jpg";